import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const UserContext = createContext(null);

export function UserProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUser = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/auth/me`);
      setUser(response.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  const refreshUser = useCallback(async () => {
    await fetchUser();
  }, [fetchUser]);

  const clearUser = useCallback(() => {
    setUser(null);
  }, []);

  const value = {
    user,
    loading,
    refreshUser,
    clearUser,
    isOwner: user?.role === "owner",
    isEditor: user?.role === "editor",
    isViewer: user?.role === "viewer",
    canEdit: user?.role === "owner" || user?.role === "editor",
    canDelete: user?.role === "owner" || user?.role === "editor",
    canEditDestination: user?.role === "owner",
    canManageTeam: user?.role === "owner"
  };

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  const context = useContext(UserContext);
  if (!context) {
    return {
      user: null,
      loading: true,
      refreshUser: async () => {},
      clearUser: () => {},
      isOwner: false,
      isEditor: false,
      isViewer: true,
      canEdit: false,
      canDelete: false,
      canEditDestination: false,
      canManageTeam: false
    };
  }
  return context;
}
